<template>
  <div class="form-alert">
    <Info :iconColor="computedIconColor" class="form-alert__icon" />
    <p>
      {{ text }}
    </p>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useGlobalStore } from "@/stores/globalStore";
import Info from "@/components/icons/Info.vue";

const globalStore = useGlobalStore();
defineProps({
  text: {
    type: String,
    required: true,
  },
});

const computedIconColor = computed(() =>
  globalStore.theme === "DARK" ? "#fff" : "rgb(17, 22, 48)"
);
</script>

<style lang="scss" scoped>
.form-alert {
  padding: $padding-std;
  display: grid;
  grid-template-columns: 0.3fr 3fr;
  align-items: start;
  border-radius: 1rem;
  background: $alert-card;
  margin-bottom: $formFieldSpacing;

  &__icon {
    width: 1.75rem;

    @include breakpoint($min-m) {
      width: 2.5rem;
    }
  }
}
</style>
